import { ApprovalMaterializedApprovalFragment } from 'generated/resources/graphql'

import MaterializedApprovalFlowUtils from 'modules/approvals/lib/MaterializedApprovalFlowUtils'

/*
 * Find the value into the approval email blocks
 */
export const findValueInBlock = (
  flow: ApprovalMaterializedApprovalFragment,
  value: string
): string => {
  const item = MaterializedApprovalFlowUtils.emailBlocks(flow)?.find(
    (emailblock) => emailblock?.key == value
  )

  return item?.value ? String(item.value) : ''
}
